import PluginsFilterSearch from './PluginsFilterSearch'
import PluginsFilterCompatibility from './PluginsFilterCompatibility'
import PluginsFilterCategory from './PluginsFilterCategory'
import PluginsFilterTag from './PluginsFilterTag'
import PluginsFilterLanguage from './PluginsFilterLanguage'
import PluginsFilterRating from './PluginsFilterRating'
import PluginsFilterPrice from './PluginsFilterPrice'
import Ad from '../../Ad'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

export default function PluginFilter ({
  applications,
  tags,
  categories,
  languages,
  query,
  updateQuery,
  plugins
}) {
  const router = useRouter()
  const { t } = useTranslation('plugins')

  return (
    <div className="col-12 col-lg-3 filterbarcontainer">
      <div className="row gy-3 gy-lg-4">
        <div className="col-12 d-lg-none">
          <button
            className="btn btn-outline-primary w-100"
            data-bs-toggle="collapse"
            data-bs-target="#filter-bar"
            role="button"
            aria-expanded="false"
            aria-controls="filter-bar"
          >
            <span className="me-2">Show Filter & Search</span>
            <svg
              viewBox="0 0 10 10"
              xmlns="http://www.w3.org/2000/svg"
              height="14"
              width="14"
            >
              <path
                d="M9.947.276A.5.5,0,0,0,9.5,0H.5A.5.5,0,0,0,.115.819L3.75,5.208V9.5a.5.5,0,0,0,.309.462A.493.493,0,0,0,4.25,10,.5.5,0,0,0,4.6,9.854l1.5-1.5A.5.5,0,0,0,6.25,8V5.231C7.714,3.705,9.809.922,9.9.8A.5.5,0,0,0,9.947.276Z"
                fill="currentColor"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0"
              ></path>
            </svg>
          </button>
        </div>
        <div
          className="collapse"
          id="filter-bar"
        >
          <div className="row gy-3">
            <div className="col-12">
              <PluginsFilterSearch
                search={query.search}
                onSearchChange={e => updateQuery({ search: e })}
                placeholder={t('browse_all.filter.search')}
              />
            </div>
            {
              plugins.meta?.facets?.categories?.buckets?.length > 0 && (
                <>
                  <div className="col-12">
                    {
                      !router.query.application && (
                        <PluginsFilterCompatibility
                          data={applications}
                          onCheckedCompatibilityChange={e => {
                            updateQuery({ filter: { ...query.filter, compatibilities: e }, page: 1 })
                          }}
                          checkedCompatibilities={query.filter.compatibilities}
                          plugins={plugins}
                        />
                      )
                    }
                  </div>
                  <div className="col-12">
                    {
                      !router.query.category && (
                        <PluginsFilterCategory
                          data={categories}
                          onCheckedCategoryChange={e => {
                            updateQuery({ filter: { ...query.filter, categories: e }, page: 1 })
                          }}
                          checkedCategories={query.filter.categories}
                          plugins={plugins}
                        />
                      )
                    }
                  </div>
                  <div className="col-12">
                    <PluginsFilterTag
                      data={tags}
                      onCheckedTagChange={e => {
                        updateQuery({ filter: { ...query.filter, tags: e }, page: 1 })
                      }}
                      checkedTags={query.filter.tags}
                      plugins={plugins}
                    />
                  </div>
                  <div className="col-12">
                    <PluginsFilterLanguage
                      data={languages}
                      onCheckedLanguageChange={e => {
                        updateQuery({ filter: { ...query.filter, languages: e }, page: 1 })
                      }}
                      checkedLanguages={query.filter.languages}
                      plugins={plugins}
                    />
                  </div>
                  <div className="col-12">
                    <PluginsFilterRating
                      onCheckedRatingChange={e => {
                        updateQuery({ filter: { ...query.filter, rating: e }, page: 1 })
                      }}
                      checkedRating={query.filter.rating}
                      plugins={plugins}
                    />
                  </div>
                  <div className="col-12">
                    <PluginsFilterPrice
                      onPriceChange={e => {
                        updateQuery({ filter: { ...query.filter, price: e }, page: 1 })
                      }}
                      price={query.filter.price}
                      plugins={plugins}
                    />
                  </div>
                </>
              )
            }
            <div className="col-12">
              <Ad
                zoneId="1"
                loadScript={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
